import { ECheckServiceErrorCode } from '../../../redux/reducers';
import { IMappers } from '../../../repositories/monolith-python/v1/check-service';
import { ICheckServiceFail, ICheckServiceSuccess } from '../types';
import { mapCheckoutInfo } from './mapCheckoutInfo';

export const mappers: IMappers<ICheckServiceSuccess, ICheckServiceFail> = {
  200: response => ({
    success: true,
    payload: mapCheckoutInfo(response),
  }),
  400: () => ({
    success: false,
    payload: ECheckServiceErrorCode.badRequest,
  }),
};
